<template>
  <div  id="app">
    <!-- <div class="big-screen"> -->
      <router-view />
    <!-- </div> -->
  </div>
</template>

<script>
import axios from 'axios'
import autofit from "autofit.js"
export default {
  
  name: 'App',
  components: {

  },
  created(){
    this.getIPAddress();
    
  },
  mounted(){
    //初始化自适应  ----在刚显示的时候就开始适配一次
    // this.handleScreenAuto();
    //绑定自适应函数   ---防止浏览器栏变化后不再适配
    // window.onresize = () => handleScreenAuto();
    this.$nextTick(()=>{
      autofit.init({
        // dw: 1920,        // 设计稿宽度（必须与 UI 设计一致）
        // dh: 932,        // 设计稿高度（必须与 UI 设计一致）
        dw: 1920,        // 设计稿宽度（必须与 UI 设计一致）
        dh: 1080,        // 设计稿高度（必须与 UI 设计一致）
        el: '#app', // 自适应目标容器（即中间层容器）
        resize: true,     // 窗口缩放时自动重新适配（建议开启）
        // allowScroll: true, // 允许滚动
        limit:0.01
      });
    })
  },
  deleted(){
    window.onresize = null;
  },
  created(){
    this.$nextTick(()=>{
      document.oncontextmenu = new Function("event.returnValue=false");//禁用右键菜单
    })
  },
  watch:{
    '$route':{
      '$route'(to, from) {  
        this.setBackground();  
      }  
    }
  },
  methods:{
     //数据大屏自适应函数
      //  handleScreenAuto(){
      //      const designDraftWidth = 1920;//设计稿的宽度
      //      const designDraftHeight = 960;//设计稿的高度
      //      //根据屏幕的变化适配的比例
      //      const scale = document.documentElement.clientWidth / document.documentElement.clientHeight < designDraftWidth / designDraftHeight ?
      //          (document.documentElement.clientWidth / designDraftWidth) :
      //          (document.documentElement.clientHeight / designDraftHeight);
      //      //缩放比例
      //      (document.querySelector('#app')).style.transform = `scale(${scale}) translate(-50%)`;
      //  }
      setBackground() {  
        const path = this.$route.path;  
        if (path.includes('/index')) {  
          this.bgClass = 'index-background';  
        } else if (path.includes('/index/')) {  
          this.bgClass = 'price-trend-background';  
        } else {  
          this.bgClass = 'default-background'; // 默认背景图片类名  
        }  
      }, 
      // 获取IP用于定位用户
      getIPAddress() {
        const url = 'http://api.ipify.org?format=json';
        axios.get(url).then(response => {
          let ipAddress = response.data.ip;
          console.log('获取的IP地址',ipAddress);
        });
      },
  }
}
</script>

<style lang="less">
  html{
    height: 100%;
    background-image: url('../src/assets/login/bg.png');
    background-size: cover;
  }
  *{
    margin: 0;
    padding: 0;
    user-select: none;
  }
  #app{
    width: 100%;
    height: 100%;
    position: relative; // 子元素绝对定位时基于此容器
    z-index: 1;
    .big-screen{
      width: 100vw; // 相对于 #big-screen-con 的 100%（即 1920px）
      // height: calc(100% - 95px); // 减去导航栏高度（95px 是设计稿中导航栏高度）
      height: 100vh; // 减去导航栏高度（95px 是设计稿中导航栏高度）
      // padding: 20px 20px 31px; // 设计稿中的内边距
      box-sizing: border-box;
    }
  }
  // .big-screen{
  //   width: 100%; // 相对于 #big-screen-con 的 100%（即 1920px）
  //   height: calc(100% - 95px); // 减去导航栏高度（95px 是设计稿中导航栏高度）
  //   // padding: 20px 20px 31px; // 设计稿中的内边距
  //   box-sizing: border-box;
  // }
</style>
